import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { hooks as h } from "@/hooks";
import { components as c } from "@/components";
import Stepper from "@/components/common/Stepper";
import InviteForm from "@/features/invite/components/InviteForm";
import { hasTeamInviteContext, validateTeamInviteSearch } from "@/features/invite/utils/teamInviteSearch";
import { getTeamInviteSteps } from "@/features/invite/utils/teamInviteSteps";
import { BackButton } from "@/features/i18n/formComponents";
import { useActionCopy } from "@/features/i18n/actionCopy";
import { useInviteCopy } from "@/features/i18n/inviteCopy";
import { formatRoleLabel, useProfileCopy } from "@/features/i18n/profileCopy";

export const Route = createFileRoute("/_app/team/invite/email")({
    component: TeamInviteEmailPage,
    validateSearch: validateTeamInviteSearch,
    beforeLoad: ({ search }) => {
        if (!hasTeamInviteContext(search)) {
            throw redirect({ to: "/team/invite" });
        }
    },
});

function TeamInviteEmailPage() {
    const search = Route.useSearch();
    const navigate = useNavigate();
    const copy = useProfileCopy();
    const inviteCopy = useInviteCopy();
    const actionCopy = useActionCopy();
    const roleLabel = formatRoleLabel(search.role?.toUpperCase(), copy) || search.role;

    h.useNav([
        { label: copy.myTeam, route: { to: "/team" } },
        { label: inviteCopy.invitePageTitle, route: { to: "/team/invite", search } },
        { label: inviteCopy.inviteByEmail, route: { to: "/team/invite/email", search } },
    ]);

    return (
        <>
            <c.cc.Title words={inviteCopy.inviteByEmail} />
            {search.organisation_name || roleLabel ? (
                <p className="text-muted-foreground text-sm">
                    {[roleLabel, search.organisation_name].filter(Boolean).join(" · ")}
                </p>
            ) : null}
            <Stepper steps={getTeamInviteSteps("email", inviteCopy, search)} />
            <InviteForm
                defaultRole={search.role}
                defaultOrganisation={JSON.stringify({
                    organisation_id: search.organisation_id,
                    organisation_name: search.organisation_name ?? "",
                })}
                onSuccess={() => {
                    void navigate({ to: "/team" });
                }}
            />
            <BackButton
                className="w-full"
                label={actionCopy.back}
                onClick={() => void navigate({ to: "/team/invite", search })}
            />
        </>
    );
}
